import { CAR_VALUE_MAX, MAX_ALLOWED_TERM_KMS } from '@/utils/constants';
import { required } from 'vuelidate/lib/validators';

function termKmsCheck(value, vm) {
  return (
    (vm.kmsPerYear || 0) * ((vm.leaseTerm || 0) / 12) <= MAX_ALLOWED_TERM_KMS
  );
}

function carValueCheck(value, vm) {
  return vm.carValue <= CAR_VALUE_MAX;
}
export default {
  customerOptions: {
    annualSalary: { required },
    vehicleCondition: { required },
    bodyType: { required },
    carValue: { required, carValueCheck },
    leaseTerm: { required, termKmsCheck },
    kmsPerYear: { required, termKmsCheck },
  },
};
